import React, { Component } from 'react';
import NiceImage from './NiceImage';

export default class WidgetImage extends Component {

  render() {
    let { mode, ...props } = this.props;
    let { src: nativeImageSrc, style: nativeImageStyle, ...nativeImageProps } = this.props;

    const imageMode = () => {
      switch (mode) {
        case "Fill":
          return "cover";
        case "Scroll":
          throw new Error("NOT SUPPORTED IN THIS SCENARIO");
        case "FitTopLeft":
        case "FitCenter":
        default:
          return "contain";
      }
    };

    const imagePosition = () => {
      switch (mode) {
        case "FitTopLeft":
          return "top left";
        case "Scroll":
          throw new Error("NOT SUPPORTED IN THIS SCENARIO");
        case "Fill":
        case "FitCenter":
        default:
          return "center center";
      }
    };

    const commonImgStyle = {
      position: "absolute",
      left: 0,
      top: 0
    };

    return (mode === "Scroll"
      ? <img alt="" style={{ ...commonImgStyle, ...nativeImageStyle }} src={nativeImageSrc} {...nativeImageProps} />
      : <NiceImage position={imagePosition()} mode={imageMode()} {...props} />);
  }
}
